export default function initFixedHeader(header) {
  const activeClass = 'header-fixed';

  handleScroll();

  window.addEventListener('scroll', handleScroll);

  function handleScroll() {
    const offsetTop = window.scrollY;
    const headerHeight = header.offsetHeight;

    if (offsetTop > headerHeight) {
      header.classList.add(activeClass);
    } else {
      header.classList.remove(activeClass);
    }
  }
}
